import { BatchManagementForm } from 'system/components/batch-management/form';

export const requestTransformerBatchManagement = (form: BatchManagementForm) =>
  ({
    name: form?.batchName,
    description: form?.description,
    enabled: form?.active,
    executorLocation: form?.microservice,
    executorName: form?.executionText,
    postExecutionMailAction: form?.postCalculation,
    mailingList: form?.mailingList,
    nmCartellaInput: form?.inputFolder,
    nmCartellaOutput: form?.outputFolder,
    note: '',
    parameters: form?.parameters?.map((param) => ({
      name: param?.name,
      description: param?.description,
      value: param?.value,
      note: '',
    })),
    schedules: form?.schedulations?.map((schedule) =>
      schedule?.schedulationType === 'EVENT'
        ? {
            description: schedule?.description,
            type: schedule?.schedulationType,
            eventSourceJobName: schedule?.eventSourceJobName,
            event: schedule?.event,
          }
        : schedule?.schedulationType === null
        ? {
            description: schedule?.description,
            type: null,
            cronExpression: null,
            event: null,
            eventSourceJobName: null,
          }
        : {
            description: schedule?.description,
            type: schedule?.schedulationType,
            cronExpression: schedule?.cronExpression,
          }
    ),
  } as const);
